module.exports = __webpack_public_path__ + "static/media/expense-tracker.3283c702.png";